import {
  UI_COLOR_BORDER_DIVIDER,
  UI_COLOR_DANGER_BORDER,
  UI_COLOR_DANGER_SOFT,
  UI_COLOR_DANGER_TEXT,
  UI_COLOR_SUCCESS_BORDER,
  UI_COLOR_SUCCESS_SOFT,
  UI_COLOR_SUCCESS_TEXT,
  UI_COLOR_TEXT_NEUTRAL,
  UI_COLOR_TEXT_SUBTITLE
} from '../../../constants/uiColors'
import {
  getFillRateProductDifferenceTone,
  resolveFillRateProductDisplayDifference
} from '../helpers/fillRateProductDifferencesFormatters'

export const FILL_RATE_PRODUCT_DETAILS_HEADER_SX = {
  alignItems: 'center',
  display: 'flex',
  gap: 2,
  justifyContent: 'space-between',
  mb: 2,
  mt: 2
}

export const FILL_RATE_PRODUCT_DETAILS_TITLE_SX = {
  m: 0
}

export const FILL_RATE_PRODUCT_DETAILS_DIVIDER_SX = {
  borderColor: UI_COLOR_BORDER_DIVIDER,
  mb: 3
}

export const FILL_RATE_PRODUCT_DETAILS_SUMMARY_SX = {
  mb: 3
}

export const FILL_RATE_PRODUCT_EMPTY_DIFFERENCE_SX = {
  color: UI_COLOR_TEXT_SUBTITLE
}

export const getFillRateProductDifferenceTotalSx = (value) => ({
  color:
    resolveFillRateProductDisplayDifference(value) > 0
      ? UI_COLOR_SUCCESS_TEXT
      : resolveFillRateProductDisplayDifference(value) < 0
        ? UI_COLOR_DANGER_TEXT
      : UI_COLOR_TEXT_NEUTRAL,
  fontWeight: 700
})

const BASE_DIFFERENCE_BADGE_SX = {
  alignItems: 'center',
  borderRadius: '4px',
  display: 'inline-flex',
  fontSize: 12,
  fontWeight: 700,
  justifyContent: 'center',
  lineHeight: 1,
  minHeight: 20,
  minWidth: 74,
  px: 1
}

const POSITIVE_DIFFERENCE_BADGE_SX = {
  ...BASE_DIFFERENCE_BADGE_SX,
  backgroundColor: UI_COLOR_SUCCESS_SOFT,
  border: `1px solid ${UI_COLOR_SUCCESS_BORDER}`,
  color: UI_COLOR_SUCCESS_TEXT
}

const NEGATIVE_DIFFERENCE_BADGE_SX = {
  ...BASE_DIFFERENCE_BADGE_SX,
  backgroundColor: UI_COLOR_DANGER_SOFT,
  border: `1px solid ${UI_COLOR_DANGER_BORDER}`,
  color: UI_COLOR_DANGER_TEXT
}

export const getFillRateProductDifferenceBadgeSx = (value) =>
  getFillRateProductDifferenceTone(value) === 'negative'
    ? NEGATIVE_DIFFERENCE_BADGE_SX
    : POSITIVE_DIFFERENCE_BADGE_SX

export const getFillRateProductDifferenceMarkerColor = (value) => {
  const tone = getFillRateProductDifferenceTone(value)

  if (tone === 'positive') return UI_COLOR_SUCCESS_TEXT
  if (tone === 'negative') return UI_COLOR_DANGER_TEXT
  return 'transparent'
}

export const getFillRateProductDifferenceMarkerStyle = (value) => ({
  boxShadow: `inset 3px 0 0 ${getFillRateProductDifferenceMarkerColor(value)}`
})
